module.exports = __webpack_public_path__ + "static/media/interior.8dfe8d85.png";